document.addEventListener("turbolinks:before-visit", function () {
  document.querySelectorAll(".toast").forEach(el => el.remove())
  document.getElementById("toastr-flash")?.remove()
})
